/**
 * handoverMemoNotes — shapes file notes for the New Business Handover Memo's
 * notepad-history pages (CLAUDE.md §35.3). Extracted verbatim from
 * FileDetail.jsx (step F2 of the FileDetail decomposition, audit §6.1).
 */

import { FILE_NOTE_ROLE_PAIR } from '../api/fileNotesApi';
import { getRoleLabel, getRoleHolderName } from '../auth/authConfig';

/**
 * Shape a file note for the handover memo's notepad-history pages:
 * author, role label (as shown in the app), timestamp and body ONLY.
 * file_notes stores no author role, so it is derived: system notes are
 * authored by "System" and carry no role label; a human note carries the
 * role that must acknowledge it, and
 * the author is the OTHER of the file's two roles; legacy notes written
 * before acknowledgement existed fall back to matching the author's
 * first name to a role holder. Acknowledgement STATE (read/unread, who,
 * when) is deliberately not carried — the memo is a record, not a
 * working surface (§31).
 */
export function toMemoNotepadEntry(note) {
  const isSystem = note.authorType === 'system';
  let roleLabel = '';
  if (!isSystem) {
    let authorRole = note.acknowledgerRole
      ? FILE_NOTE_ROLE_PAIR.find((r) => r !== note.acknowledgerRole)
      : null;
    if (!authorRole) {
      authorRole = FILE_NOTE_ROLE_PAIR.find((r) => getRoleHolderName(r) === note.authorDisplayName) || null;
    }
    roleLabel = authorRole ? getRoleLabel(authorRole) : '';
  }
  return {
    author: isSystem ? 'System' : (note.authorDisplayName || ''),
    roleLabel,
    createdAt: note.createdAt,
    body: note.body || '',
    isSystem,
  };
}
